// src/pages/B2B/event-reports/pdf/warm/charts/SpotlightMiniChart.tsx
import React from 'react';
import { EngagementChart } from './EngagementChart';
import type { ActiveUsersSample, BroadcastRow } from '../../../types';

interface Props {
  samples: ActiveUsersSample[];
  triggerNotification: BroadcastRow | null;
  timezone: string;
  windowStartUtcIso: string;
  windowMinutes: number;
}

export function SpotlightMiniChart(props: Props): React.ReactElement {
  const { samples, triggerNotification, timezone, windowStartUtcIso, windowMinutes } = props;
  return (
    <EngagementChart
      samples={samples}
      goingClickIsoTimes={[]}
      notifEvents={triggerNotification ? [triggerNotification] : []}
      timezone={timezone}
      windowStartUtcIso={windowStartUtcIso}
      windowMinutes={windowMinutes}
      width={760}
      height={260}
      showGoingBars={false}
      highlightTopPeaks={0}
    />
  );
}
